'use client';
import { useTantoSvagoStore } from '@/store';
import { useEffect, useState } from 'react';

export const useIsWelfare = () => {
  const { apiHeaders } = useTantoSvagoStore();
  const [isWelfare, setIsWelfare] = useState(false);
  // On server tantoSvago is always false, we do like this to avoid hydration mismatch
  useEffect(() => {
    setIsWelfare(!!apiHeaders.Authorization);
  }, [apiHeaders.Authorization]);

  return isWelfare;
};
